<template>
    <b-modal
            id="verify-modal"
            title="Verification Code"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="text-center">
                <p class="text-center">
                    <b
                        >{{subtitle}}</b
                    >
                </p>
                <div id="form">
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep1"
                        @paste="onPaste"
                    ></masked-input>
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep2"
                        @paste="onPaste"
                    ></masked-input>
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep3"
                        @paste="onPaste"
                    ></masked-input>
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep4"
                        @paste="onPaste"
                    ></masked-input>
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep5"
                        @paste="onPaste"
                    ></masked-input>
                    <masked-input
                        type="text"
                        maxLength="1"
                        size="1"
                        :mask="[/[0-9]/, /\d/]"
                        @keydown="checkNumber"
                        :guide="false"
                        ref="vStep6"
                        @paste="onPaste"
                    ></masked-input>
                </div>
                <b-button class="mt-3" variant="primary" @click="dropCode">
                    Verify
                </b-button>
            </div>
        </b-modal>
</template>
<script>
import MaskedInput from "vue-text-mask";
export default {
    name: 'VerificationCode',
    components: {
        MaskedInput
    },
    props: {
        subtitle: {
            type: String,
            default: 'Please enter the verification code sent to your phone number'
        }
    },
    methods: {
        initialize() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.vStep1.$el.focus();
                }, 500);
            });
        },
        dropCode(){
            let code = '';
            for(let i = 1; i <= 6; i++){
                code += this.$refs['vStep'+i].$el.value;
            }
            if(code.length < 6){
                return;
            }
            this.$emit('dropCode', code);
        },
        checkNumber(event) {
            if (!isNaN(event.key)) {
                event.preventDefault();
                event.target.value = event.key;
                if(event.target.nextSibling){
                    if(event.target.nextSibling.tagName.toLowerCase() === "input"){
                        event.target.nextSibling.focus();
                    }else if(event.target.nextSibling.tagName.toLowerCase() === "div"){
                        event.target.nextSibling.nextSibling.focus();
                    }
                }else{
                    this.dropCode();
                }
            } else {
                if(event.key.toLowerCase() === "backspace" && event.target.previousSibling){
                    event.preventDefault();
                    event.target.value = "";
                    if(event.target.previousSibling.tagName.toLowerCase() === "input"){
                        event.target.previousSibling.focus();
                    }else if(event.target.previousSibling.tagName.toLowerCase() === "div"){
                        event.target.previousSibling.previousSibling.focus();
                    }
                }
                if(event.key.toLowerCase() === "arrowright" && event.target.nextSibling){
                    event.preventDefault();
                    if(event.target.nextSibling.tagName.toLowerCase() === "input"){
                        event.target.nextSibling.focus();
                    }else if(event.target.nextSibling.tagName.toLowerCase() === "div"){
                        event.target.nextSibling.nextSibling.focus();
                    }
                }
                if(event.key.toLowerCase() === "arrowleft"  && event.target.previousSibling){
                    event.preventDefault();
                    if(event.target.previousSibling.tagName.toLowerCase() === "input"){
                        event.target.previousSibling.focus();
                    }else if(event.target.previousSibling.tagName.toLowerCase() === "div"){
                        event.target.previousSibling.previousSibling.focus();
                    }
                }
            }
        },
        onPaste(e){
            var clipboardData, pastedData;
            e.stopPropagation();
            e.preventDefault();
            clipboardData = e.clipboardData || window.clipboardData;
            pastedData = clipboardData.getData('Text');
            let code = pastedData.slice(0, 7);
            let codeArr2 = code.split('');
            for(let i = 1; i <= 6; i++){
                this.$refs['vStep'+i].$el.value = codeArr2[i-1];
            }
            this.$refs['vStep6'].$el.focus();
            this.dropCode();
        }
    }
}
</script>